(function() { window.GUID_140d96e0_f893_4097_a5dc_ba1d5fe0168f = { getGuid: function() { return "140d96e0-f893-4097-a5dc-ba1d5fe0168f"; } }; })();
var ChartAutoRefresh;
(function (ChartAutoRefresh) {
    var refresh = parseInt($('#OneItemRefreshTime').val(), 10);
    if (refresh && refresh > 100) {
        setInterval(function () {
            var canvas = $('#Canvas');
            CompuSport.Ajax.Get(CSParameters.RUrl + "Charts/ChartFullScreenForAutoRefresh/" + CSParameters.SportEventId + window.location.search, null, function (queryResult) {
                canvas[0].innerHTML = queryResult;
            });
        }, refresh);
    }
})(ChartAutoRefresh || (ChartAutoRefresh = {}));

//# sourceMappingURL=ChartAutoRefresh.js.map
